import Keycloak from 'keycloak-js'
import { createPinia, defineStore, setActivePinia } from 'pinia'

setActivePinia(createPinia())

export const useKeycloak = defineStore('keycloak', () => {
  const token = ref<string | null>(window.localStorage.getItem('token'))
  const refreshToken = ref<string | null>(window.localStorage.getItem('refreshToken'))
  const isLoading = ref<boolean>(true)

  const isAuthenticated = ref<boolean>(false)

  const config = useRuntimeConfig()

  const keycloak = new Keycloak({
    url: config.public.keycloakUrl,
    realm: config.public.keycloakRealm,
    clientId: config.public.keycloakClientId,
  })

  keycloak.onTokenExpired = () => {
    updateToken()
  }

  keycloak
    .init({
      checkLoginIframe: false,
      token: token.value ?? undefined,
      refreshToken: refreshToken.value ?? undefined,
      redirectUri: `${window.origin}/`,
    })
    .then((auth) => {
      if (auth) {
        setTokens()
        isAuthenticated.value = true
      }
      isLoading.value = false
    })
    .catch((_) => {
      clearTokens()
      isLoading.value = false
      // window.location.reload()
    })

  function setTokens() {
    window.localStorage.setItem('token', keycloak.token ?? '')
    window.localStorage.setItem('refreshToken', keycloak.refreshToken ?? '')
    token.value = keycloak.token ?? ''
    refreshToken.value = keycloak.refreshToken ?? ''
  }

  function clearTokens() {
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('refreshToken')
    token.value = null
    refreshToken.value = null
    isAuthenticated.value = false
  }

  async function login() {
    await keycloak.login()
  }

  async function logout(unauthenticated?: boolean) {
    if (!isAuthenticated.value) return
    keycloak.logout({
      redirectUri: `${window.origin}/loginSelection${unauthenticated ? '?unauthenticated=true' : ''}`,
    })
    clearTokens()
    window.localStorage.removeItem('shown_expiring_list')
  }

  async function waitForKeycloak() {
    await until(isLoading).toBe(false, { timeout: 1000 })
  }

  async function updateToken() {
    try {
      const refresh = await keycloak.updateToken()
      if (refresh) {
        setTokens()
      }
    }
    catch (_) {
      clearTokens()
    }
  }

  return {
    keycloak,
    login,
    logout,
    isAuthenticated,
    waitForKeycloak,
    updateToken,
  }
})
